import axios from 'axios';

export const validateId = async (queryParams) => {
  const { data } = await axios.post('/users/validate-id', queryParams);

  return data;
};
